import Device from "../../../../js/assets/device.js"
import WindowScroll from "../../../../js/assets/window_scroll.js"
import Component from "../../../../js/assets/component.js"
import LpDetailBlock from "./lp_detail_block.js"
import ButonLpDetailBlock from "./button_lp_detail_block.js"

class LpDetailBlockList extends Component {
  constructor(el){
    super(el)

    Device.addEventListener("device_mode", (data)=>{
      this.$data.device_mode = data
    })
    this.$data.device_mode = Device.$data.device_mode

    WindowScroll.addEventListener("scrollTop", (data) => {
      this.$data.scrollTop = data.scrollTop
    })

    this.$data.windowHeight = $(window).height()
    window.addEventListener("resize", ()=>{
      this.$data.windowHeight = $(window).height()
    })
  }

  data(){
    return {
      "windowHeight": null,
      "scrollTop": null,
      "activeIndex": null,
      "maxIndex": null,
      "device_mode": null
    }
  }

  changed(){
    return {
      "scrollTop": (val)=>{
        if(this.$data.device_mode !== "pc"){
          return
        }
        this.activateBlockInView(val)
      },
      "activeIndex": (index, prev)=>{
        this.switchPage()
        this.switchPagination()
        this.switchNextPageListItem()
        this.switchNextPrevIndex()
      },
      "device_mode": (device_mode)=>{
        this.switchPage()
        this.switchPagination()
        this.switchNextPageListItem()
        this.switchNextPrevIndex()
      }
    }
  }

  activate(){
    this.$el.removeClass("-inActive")
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
    this.$el.addClass("-inActive")
  }

  switchPage(device_mode){
    switch(this.$data.device_mode){
      case Device.DEVICE_MODE_SP:
        this.switchPageSP(this.$data.activeIndex)
        break
      case Device.DEVICE_MODE_PC:
        this.switchPagePC(this.$data.activeIndex)
        break
    }
  }

  switchPageSP(){
    //
    for(let i=0; i < this.lpDetailBlock.length; i++){
      if(i===this.$data.activeIndex){
        this.lpDetailBlock[i].$data.active = true
      }else{
        this.lpDetailBlock[i].$data.active = false
      }
    }

  }

  switchPagePC(index){
    //scroll to


  }
  //PC表示の際にスクロールで表示領域に入ったらactivate
  activateBlockInView(scrollTop){

    for(let i=0; i < this.lpDetailBlock.length; i++){
      let elOffsetTop = this.lpDetailBlock[i].$el.offset().top
      let elHeight = this.lpDetailBlock[i].$el.height()
      let diff = elOffsetTop - this.$data.windowHeight

      if((elOffsetTop + elHeight) <= scrollTop){
        this.lpDetailBlock[i].$data.active = false
      }else if(diff <= scrollTop){
        // console.log("in")
        this.lpDetailBlock[i].$data.active = true
      }else{
        this.lpDetailBlock[i].$data.active = false
      }
    }
  }

  switchPagination(){
    for(let i=0; i<this.pagination.length; i++){
      if(this.pagination[i].$data.blockIndex === this.$data.activeIndex){
        this.pagination[i].activate()
      }else{
        this.pagination[i].inActivate()
      }
    }
  }

  switchNextPrevIndex(){
    let activeIndex = this.$data.activeIndex
    let nextIndex = activeIndex + 1
    if(nextIndex >= this.$data.maxIndex){
      nextIndex = null
    }
    let prevIndex = activeIndex - 1
    if(prevIndex < 0){
      prevIndex = null
    }

    this.butonLpDetailBlockPrev.$data.blockIndex = prevIndex
    this.butonLpDetailBlockNext.$data.blockIndex = nextIndex
  }

  switchNextPageListItem(){
    if(this.$data.activeIndex >= this.nextPage.length-1){
      this.$nextPageContainer.removeClass("-active")
      return
    }

    this.$nextPageContainer.addClass("-active")
    for(let i=0; i<this.nextPage.length; i++){
      if(this.nextPage[i].$data.blockIndex === this.$data.activeIndex+1){
        this.nextPage[i].activate()
      }else{
        this.nextPage[i].inActivate()
      }
    }
  }

  mounted() {
    var self = this

    //LpDetailBlock
    this.lpDetailBlock = []
    this.$el.find(".lpDetailBlock").each(function(i){
      self.lpDetailBlock[i] = new LpDetailBlock($(this).get(0))
    })
    this.$data.maxIndex = this.lpDetailBlock.length

    //pagination
    this.pagination = []
    this.$el.find("li.pagination_item").each(function(i){
      self.pagination[i] = new ButonLpDetailBlock($(this), Number($(this).attr("data-block")))
      self.pagination[i].$el.on("click", function(){
        self.$data.activeIndex = Number(self.pagination[i].$data.blockIndex)
        return false
      })
    })

    //prev
    this.butonLpDetailBlockPrev = new ButonLpDetailBlock(this.$el.find(".pagination_prev").get(0), null)
    this.butonLpDetailBlockPrev.$el.on("click", function(){
      self.$data.activeIndex = Number(self.butonLpDetailBlockPrev.$data.blockIndex)
      return false
    })

    //next
    this.butonLpDetailBlockNext = new ButonLpDetailBlock(this.$el.find(".pagination_next").get(0), 1)
    this.butonLpDetailBlockNext.$el.on("click", function(){
      self.$data.activeIndex = Number(self.butonLpDetailBlockNext.$data.blockIndex)
      return false
    })

    //nextPage
    this.$nextPageContainer = this.$el.find(".nextPageList")
    this.nextPage = []
    this.$el.find("li.nextPageList_item").each(function(i){
      self.nextPage[i] = new ButonLpDetailBlock($(this), Number($(this).attr("data-block")))
      self.nextPage[i].$el.on("click", function(){
        self.$data.activeIndex = Number(self.nextPage[i].$data.blockIndex)
        return false
      })
    })

    //init activeIndex
    this.$data.activeIndex = 0;

    //on print
    window.addEventListener("beforeprint", async ()=>{
      for(let i=0; i < this.lpDetailBlock.length; i++){
        this.lpDetailBlock[i].$data.active = true
      }
    })
  }
}

export default LpDetailBlockList
